// src/components/FaunaRace/FaunaHomeScreen.js
import React from 'react';
import styles from './FaunaRace.module.css';
import { ACTIONS } from './FaunaRaceGame';
import FaunaBackground from './FaunaBackground';

const ANIMAL_PARADE_ICONS = ['😊', '🦁', '🐘', '🐯', '😄', '🦅', '🐸', '😃', '🐧', '🦋'];

// Fungsi helper untuk fungsionalitas fullscreen
const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err => {
            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
            // Opsional: Tampilkan pesan kepada pengguna bahwa fullscreen tidak didukung
            alert("Mode layar penuh tidak didukung atau diblokir oleh browser Anda.");
        });
    } else {
        document.exitFullscreen();
    }
};

function FaunaHomeScreen({ dispatch, onGoHome }) {
    return (
        // Container utama sekarang tidak memiliki background sendiri
        <div className={styles.container}>
            {/* 1. Komponen background sekarang terpisah dan berada di belakang segalanya */}
            <FaunaBackground />

            <div className={styles.homeScreen}>
                <div className={styles.titleContainer}>
                    <div className={styles.animalParade}>
                        {ANIMAL_PARADE_ICONS.map((icon, index) => (
                             <span 
                                key={index} 
                                className={styles.animalIcon} 
                                style={{ animationDelay: `${index * 0.2}s` }}
                            >
                                {icon}
                            </span>
                        ))}
                    </div>
                    <h1 className={styles.gameTitle}>DUNIA RIMBA</h1>
                </div>
                <p className={styles.gameSubtitle}>Guru Inspiratif</p>
                
                <div className={styles.menuButtons}>
                    {/* Tombol MAIN */}
                    <button 
                        className={styles.woodButton} 
                        onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'mode' } })}
                    >
                        MAIN
                    </button>
                    
                    {/* Tombol LAYAR PENUH (sekarang dengan fungsionalitas) */}
                    <button 
                        className={styles.woodButton}
                        onClick={toggleFullscreen}
                    >
                        LAYAR PENUH
                    </button>
                    
                    {/* Tombol KEMBALI KE MENU UTAMA (sekarang dengan fungsionalitas) */}
                    <button 
                        className={styles.woodButton} 
                        style={{
                            marginTop: '20px', 
                            background: 'linear-gradient(145deg, #1e6b0a, #1a4d0a)', // Warna lebih gelap agar kontras
                            color: '#fff'
                        }}
                        onClick={onGoHome}
                    >
                        KEMBALI KE MENU UTAMA
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FaunaHomeScreen;